export default "__VITE_ASSET__BjiNjb3C__"